import React from 'react';
import Footer from '../components/Footer/Footer';

import '../Pages/css/Campus.css';
import gallery_1 from '../components/assets/academy (3).jpg';
import gallery_2 from '../components/assets/academy (2).jpg';
import gallery_3 from '../components/assets/motivational.jpg';
import gallery_4 from '../components/assets/coursesession.jpg';
import gallery_5 from '../components/assets/IMG-20250215-WA0006.jpg';
import gallery_6 from '../components/assets/Ourfacalty.jpg';
import gallery_7 from '../components/assets/EventHall.jpg'; 
// import gallery_8 from '../components/assets/IMG-20250215-WA0012.jpg'; 
// import gallery_9 from '../components/assets/IMG-20250215-WA0017.jpg'; 
import gallery_10 from '../components/assets/IMG-20250215-WA0013.jpg'; 
// import gallery_11 from '../components/assets/IMG-20250215-WA0018.jpg'; 
import gallery_12 from '../components/assets/Alumini.jpg'; 
import gallery_13 from '../components/assets/workshop.jpg'; 
import gallery_14 from '../components/assets/groupstudy.jpg'; 
import gallery_15 from '../components/assets/IMG-20250215-WA0003.jpg'; 
import gallery_16 from '../components/assets/IMG-20250215-WA0011.jpg'; 

const Campus = () => {
  return (
    <>
      <div className="campus">
        {/* Heading */}
        <div className="heading-container">
          <h2>Campus</h2>
        </div>

        {/* Gallery and Content Section */}
        <div className="gallery-collage">
          
          {/* Image and Content 1 */}
          <div className="image-content">
            <img src={gallery_1} alt="Gallery 1" className="collage-img large-img" />
            <div className="content">
              <h3>Reception</h3>
              <p>
                Our reception area provides a welcoming environment for visitors. Our friendly receptionists will assist you with any questions and give you information about the campus, courses, and events.
              </p>
            </div>
          </div>

          {/* Image and Content 2 */}
          <div className="image-content">
            <img src={gallery_2} alt="Gallery 2" className="collage-img" />
            <div className="content">
              <h3>Course Inquiry</h3>
              <p>
                Have questions about our courses? We provide all the information you need about program structures, fees, and anything else to help you make an informed decision.
              </p>
            </div>
          </div>

          {/* Image and Content 3 */}
          <div className="image-content">
            <img src={gallery_3} alt="Gallery 3" className="collage-img" />
            <div className="content">
              <h3>Motivational Sessions</h3>
              <p>
                Our motivational sessions are designed to inspire students to reach their full potential. We help students overcome obstacles and stay focused on their career goals.
              </p>
            </div>
          </div>

          {/* Image and Content 4 */}
          <div className="image-content">
            <img src={gallery_4} alt="Gallery 4" className="collage-img" />
            <div className="content">
              <h3>Course Sessions</h3>
              <p>
                We offer a wide variety of interactive course sessions, designed to provide both theoretical knowledge and hands-on experience in different fields.
              </p>
            </div>
          </div>

          {/* Image and Content 5 */}
          <div className="image-content">
            <img src={gallery_5} alt="Gallery 5" className="collage-img" />
            <div className="content">
              <h3>Campus Life</h3>
              <p>
                Experience the vibrant campus life at MH Academy, where students are engaged in extracurricular activities, community events, and more.
              </p>
            </div>
          </div>

          {/* Image and Content 6 */}
          <div className="image-content">
            <img src={gallery_6} alt="Gallery 6" className="collage-img large-img" />
            <div className="content">
              <h3>Our Facilities</h3>
              <p>
                Explore our state-of-the-art facilities designed to offer an ideal learning environment. We aim to provide students with the best resources for their success.
              </p>
            </div>
          </div>

          {/* Image and Content 7 */}
          <div className="image-content">
            <img src={gallery_7} alt="Gallery 7" className="collage-img" />
            <div className="content">
              <h3>Event Hall</h3>
              <p>
                Our event hall hosts various seminars, workshops, and student events. It is an ideal space for collaborative learning and networking opportunities.
              </p>
            </div>
          </div>

          {/* Image and Content 8
          <div className="image-content">
            <img src={gallery_8} alt="Gallery 8" className="collage-img" />
            <div className="content">
              <h3>Library</h3>
              <p>
                Our library is equipped with a vast collection of books, journals, and digital resources to support students in their academic journey.
              </p>
            </div>
          </div> */}

          {/* Image and Content 9
          <div className="image-content">
            <img src={gallery_9} alt="Gallery 9" className="collage-img" />
            <div className="content">
              <h3>Sports Facility</h3>
              <p>
                We offer a variety of sports facilities to keep students physically active and healthy. Our gym, outdoor courts, and fitness areas cater to all skill levels.
              </p>
            </div>
          </div> */}

          {/* Image and Content 10 */}
          <div className="image-content">
            <img src={gallery_10} alt="Gallery 10" className="collage-img" />
            <div className="content">
              <h3>Student Dormitories</h3>
              <p>
                Our student dormitories provide a safe and comfortable living space for students. Each dorm is equipped with the necessary amenities for a productive stay.
              </p>
            </div>
          </div>

          {/* Image and Content 11
          <div className="image-content">
            <img src={gallery_11} alt="Gallery 11" className="collage-img" />
            <div className="content">
              <h3>Cafeteria</h3>
              <p>
                Enjoy a variety of healthy meals and snacks at our campus cafeteria. We offer nutritious and delicious food options for students to stay energized throughout the day.
              </p>
            </div>
          </div> */}

          {/* Image and Content 12 */}
          <div className="image-content">
            <img src={gallery_12} alt="Gallery 12" className="collage-img" />
            <div className="content">
              <h3>Alumni Network</h3>
              <p>
                Our alumni network is a vital part of the MH Academy community. Stay connected with fellow graduates and access exclusive job opportunities and career advice.
              </p>
            </div>
          </div>

          {/* Image and Content 13 */}
          <div className="image-content">
            <img src={gallery_13} alt="Gallery 13" className="collage-img" />
            <div className="content">
              <h3>Workshops</h3>
              <p>
                We host regular workshops on various topics to enhance students' skills and knowledge. These workshops are led by industry experts and professionals.
              </p>
            </div>
          </div>

          {/* Image and Content 14 */}
          <div className="image-content">
            <img src={gallery_14} alt="Gallery 14" className="collage-img" />
            <div className="content">
              <h3>Group Study Areas</h3>
              <p>
                Our campus offers dedicated group study areas where students can collaborate, share ideas, and work on projects together.
              </p>
            </div>
          </div>

          {/* Image and Content 15 */}
          <div className="image-content">
            <img src={gallery_15} alt="Gallery 15" className="collage-img" />
            <div className="content">
              <h3>Outdoor Learning</h3>
              <p>
                Enjoy learning outside the classroom with our outdoor learning spaces, designed to help students engage with nature while pursuing their education.
              </p>
            </div>
          </div>

          {/* Image and Content 16 */}
          <div className="image-content">
            <img src={gallery_16} alt="Gallery 16" className="collage-img" />
            <div className="content">
              <h3>Study Lounges</h3>
              <p>
                Relax and study in our comfortable and quiet study lounges, equipped with all the resources you need to focus and succeed.
              </p>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default Campus;
